module.exports = {
  common: {
    edit: "Sửa",
    apply: "Ứng dụng",
    activate: "Kích hoạt",
    delete: "Xóa",
    cancel: "Hủy",
    success: "Xong!",
    fail: "Lỗi",
    save: "Lưu",
    ensure: "Ok",
    submit: "Gửi",
    remark: "Note",
    detail: "Xem",
    action: "Vận hành",
    open: "Bật",
    close: "Tắt",
    back: "Trở về",
    export: "Xuấ",
    modify: "Sửa đổi",
    layout: "Thoát",
    noListData: "Danh sách rỗng",
    more: "Mô tả",
    add: "Mới",
    delSuccess: "Xóa thành công!",
    addFailure: "Thêm lỗi",
    logOut: "Thoát",
    delAllInfo: "Bạn có muốn tiếp tục thao tác xóa không?",
    saveTip: "Bạn chưa lưu nội dung trang, bạn có muốn tiếp tục rời đi không?",
    tip: "Nhắc",
    yes: "Có",
    no: "Không",
    delTip: "Kiểm tra kích hoạt",
    batchDelete: "Xóa theo lô",
    search: "Tìm",
    permission: "Chưa có quyền, vui lòng trở lại",
    reset: "Đặt lại",
  },
  breadcrumbItem: {
    home: "Cấu hình danh sách tên",
    data: "Gói cấu hình thiết bị chung",
    alarm: "Vùng phòng thủ",
    house: "Cấu hình bố trí",
    name: "Cấu hình danh sách tên",
  },
  errorRes: {
    res82: "Hệ thống bận, vui lòng thử lại sau",
  },
  openConfig: {
    title: "Cấu hình thiết bị chung",
    version: "Giao thức",
    versionTip: "Vui lòng chọn phiên bản giao thức",
    checkVersion: "Phiên bản thỏa thuận không được để trống",
    signType: "Loại thuật toán chữ ký",
    checkSignType: "Loại thuật toán chữ ký không được trống, vui lòng chọn lại",
    fileLabel: "Chọn tệp",
    addFile: "Thêm tệp",
    fileName: "tên tệp",
    zipType: "chế độ nén tệp",
    noZip: "Không nén",
    noFile: "Chưa thêm tệp",
    checkFile: "Hồ sơ trống, vui lòng thêm tệp",
    name: "Tên",
    nameTip: "Độ dài từ 1-10 ký tự",
    checkName: "Tên không được để trống",
    checkName1: "Nhập tên sai, vui lòng nhập lại",
    room: "Số thiết bị",
    roomTip: "Độ dài nhập từ 1-24 ký tự, phân biệt cấp bậc bằng dấu '-'",
    checkRoom: "Số thiết bị không được để trống",
    checkRoom1: "Nhập số thiết bị sai, vui lòng nhập lại",
    pic: "Ảnh",
    add: "Thêm",
    reset: "Đặt lại",
    picTip: "Tệp ảnh tải lên tối đa 3MB",
    checkPic: "Tệp ảnh không được trống, vui lòng chọn lại",
    imgRegTip: "Chỉ cho phép tệp có định dạng jpg, jpeg, png",
    excRegTip: "Chỉ cho phép tệp có định dạng xls, xlsx",
    zipRegTip: "Chỉ cho phép tải lên tệp ở định dạng zip",
    produce: "Xây dựng hồ sơ",
    confType: "loại cấu hình",
    pack: "Gói",
    batchAdd: "Thêm lô",
    singleAdd: "Thêm lẻ",
    modelBatch: "Mẫu",
    uploadInfo: "Tải lên",
    uploadPic: "Tải lên ảnh zip",
    addName: "Thêm",
    sameTip: "Số sê-ri:",
    sameTip1: "Số thiết bị bị trùng",
    modelError:
      "Nội dung tệp thông tin cơ bản đã tải lên không chính xác, vui lòng sửa tệp theo mẫu",
    noPic: "Không có dữ liệu được thêm, xin hoàn thiện tệp cấu hình",
    picBtnTip: "Vui lòng tải lên tệp thông tin cơ bản",
    devType: "Thiết bị",
    devTypeTip: "Vui lòng chọn loại thiết bị",
    checkDevType: "Loại thiết bị không được để trống",
    indexName: "Số sê-ri",
    IS: "Là",
    GU: "Bảo vệ",
    OS1: "Trạm cửa",
    OS2: "Cổng bảo vệ ngoài",
    OS3: "Máy cửa nhỏ",
    nameListTip:
      "Trong dữ liệu cơ bản cần tải lên, một số dữ liệu có trường tên chưa đầy đủ đã được nhập",
    numListTip:
      "Trong dữ liệu cơ bản cần tải lên, trường ID thiết bị chưa đầy đủ. Các dữ liệu khác đúng đã được nhập",
  },
  alarm: {
    ad: "Khu phòng thủ AD",
    io: "Khu phòng thủ IO",
    alarmPlus: "Khu phòng thủ mở rộng",
    num: "Số",
    open: "On",
    close: "Off",
    machine: "Loại cảm biến",
    sendType: "Kích hoạt",
    mode: "Mode",
    mType1: "H.ngoại",
    mType2: "Cảm biến cửa",
    mType3: "Cảm biến cửa sổ",
    mType4: "Gas",
    mType5: "Khói",
    mType6: "Chuông",
    mType7: "Tay vào nút",
    mType8: "Cửa từ tính hồng ngoại",
    mType9: "Cửa từ tính tay",
    mType10: "Rung",
    mType11: "Áp suất",
    mType12: "Khác",
    send1: "Báo cáo trong vòng 24h",
    send2: "Báo động trễ",
    send3: "Trễ giao hàng",
    send4: "Báo ngay cho cảnh sát",
    send5: "B.động chéo",
    mode1: "Thường mở",
    mode2: "Thường đóng",
    presence: "Ở nhà",
    leaving: "Ra ngoài",
    timeSet: "Cài đặt thời gian bật/tắt hệ thống",
    delayTime: "Độ trễ kích hoạt hệ thống",
    startDelay: "Độ trễ kích hoạt báo động",
    startUtil: "Thời gian báo động",
    associated: "Các vùng liên kết",
  },
  house: {
    dev: "T.bị",
    scene: "Cảnh",
    vine: "Cảm biến",
    single: "Chế độ ngữ cảnh",
    light: "Đèn",
    air: "Điều hòa",
    heat: "Sưởi ấm dưới sàn",
    fresh: "Tươi mát",
    switch: "Ổ cắm",
    curtain: "Rèm",
    water: "Máy n.nóng",
    bgm: "Nhạc nền",
    cust: "Tuỳ chỉnh",
    slight: "Đèn",
    sAir: "Điều hòa",
    sHeat: "Sưởi ấm dưới sàn",
    sFresh: "Tươi mát",
    sSwitch: "Ổ cắm",
    sCurtain: "Rèm",
    sWater: "Máy n.nóng",
    sBgm: "Nhạc nền",
    sCust: "Chỉnh",
    IndependentControl: "Kịch bản điều khiển độc lập",
    scene1: "Cảnh 1",
    scene2: "Cảnh 2",
    scene3: "Cảnh 3",
    scene4: "Cảnh 4",
    scene5: "Cảnh 5",
    scene6: "Cảnh 6",
    scene7: "Cảnh 7",
    scene8: "Cảnh 8",
    temp1: "Nhiệt độ",
    temp2: "Độ ẩm",
    temp3: "Mê-tan",
    temp4: "TVOC",
    picTip: "Không có kế hoạch",
    upload: "Tải lên kế hoạch",
    imgSize: "Kích thước hình ảnh của một bản vẽ nhà không được vượt quá 10M",
    imgName:
      "Tên của tệp bản vẽ căn hộ tải lên không được xuất hiện bằng tiếng Trung. Vui lòng chọn tên khác",
    imgLength:
      "Tổng số bản đồ loại nhà tải lên và thêm vào không được vượt quá 8. 8 hình ảnh đầu tiên trong thư mục đã được chọn tự động",
    imgCheckTip: "Bản đồ nhà không khớp. Vui lòng tải lên lại",
    room1: "Hình mẫu cửa 1",
    room2: "Hình mẫu cửa 2",
    room3: "Hình mẫu cửa 3",
    room4: "Hình mẫu cửa 4",
    room5: "Hình mẫu cửa 5",
    room6: "Hình mẫu cửa 6",
    room7: "Hình mẫu cửa 7",
    room8: "Hình mẫu cửa 8",
    download: "Xuất",
    input: "Nhập cấu hình",
    title: "Danh sách tham số",
    name: "Tên",
    location: "Vị trí",
    start: "Start",
    see: "H.thị",
    noSee: "Ẩn h.thị",
    belong: "Thuộc",
    bgIcon: "Icon Blue Ash",
    vineTip:
      "Vui lòng chọn sơ đồ loại nhà trước khi thiết lập thuộc tính điều khiển nhiệt độ.",
    sceneTip: "Vui lòng chọn loại nhà và sau đó cài đặt các thuộc tính cảnh",
    dragTip: "Vui lòng chọn bản đồ mô hình nhà và sau đó kéo để thao tác.",
    editTip: "Chỉnh xong!",
    addTip: "Khi tải lên, bạn cần chọn tất cả các kế hoạch nhà một lần.",
    editError: "Vui lòng chỉ định trước khi chỉnh sửa",
    delError: "Vui lòng chỉ định nội dung trước khi xóa.",
    delTip: "Xóa thành công",
    imgAddTip:
      "Tổng số bản đồ loại nhà tải lên và thêm vào đã đạt 8, không thể thêm lại",
    houseTitle: "Đổi kế hoạch nhà ở:",
    delHouseTip:
      "Thao tác này sẽ xóa bản đồ loại nhà và nội dung cấu hình. Bạn có muốn tiếp tục không?",
    sendTip:
      "Nhập nội dung cấu hình và chỉnh sửa lại. Bạn có thể tải lên tệp XML",
    checkType:
      "Định dạng của tệp tải lên không chính xác. Kiểm tra nội dung tệp và tải lại tệp",
    importTip: "Đang nhập tệp cấu hình",
    importTip1: "Nhập bản đồ loại nhà tương ứng",
    upLoadBtn: "Upload",
    picContent:
      "Trình tự tải lên của sơ đồ hộ gia đình phải giống với trong tệp cấu hình",
    successFile: "Tải lên tệp cấu hình thành công",
    vineTipCheck: "Tên không được để trống, vui lòng xác nhận nhập.",
    picNumMax:
      "Vui lòng xác nhận số lượng hình ảnh đã nhập, số lượng hình ảnh hiện tại lớn hơn số bản vẽ trong tệp cấu hình. Vui lòng chọn lại.",
    picNumMin:
      "Vui lòng xác nhận số lượng hình ảnh đã nhập, số lượng hình ảnh hiện tại ít hơn số bản vẽ trong tệp cấu hình. Vui lòng chọn lại.",
    maxSizeTip:
      "Số lượng thiết bị đã thêm hoặc tổng số thiết bị đã thêm vượt quá giới hạn. Nếu bạn muốn thêm thiết bị hoặc kịch bản, hãy sắp xếp thiết bị hoặc kịch bản đã thêm trước.",
    devNameTip: "Vui lòng nhập tên",
    chromeTip: "Nên sử dụng Chrome",
    downTip: "Nhấp vào liên kết tải xuống",
    imgRegTip: "Chỉ cho phép các tệp định dạng jpg, jpeg",
    threeTitle: "Hệ thống Ba Hằng Số",
    mainControl: "Chủ",
    sedControl: "Nhánh",
    controlBtn: "Cấu hình",
    configEdit: "Chi tiết về cấu hình hệ thống Sanheng",
    moveTip: "Kéo biểu tượng vào khu vực của bản đồ loại nhà, sau đó kéo lại",
    repeatNameTip: "Bản kế hoạch căn hộ bị trùng tên, vui lòng chọn tên khác",
    space: "(dự trữ)",
  },
  updateConfig: {
    tip0: "Đặt công tắc bật khi thiết lập 24 giờ",
    tip1: "Khi thiết lập 24 giờ, công tắc phải được bật",
    tip2: "Khi thiết lập báo động ngay lập tức, công tắc phải được bật",
    tip3: "Khi báo động trì hoãn tắt, độ trễ truyền tải phải được tắt",
    tip4: "Báo động chéo đã được thiết lập, cần phải liên kết",
    tip5: "Vui lòng bật báo động trì hoãn trước",
    tip6: "Khi đặt báo động tức thì, hãy bật công tắc ON",
  },
  audio: {
    title: "Công cụ đóng gói giọng nói",
    lock: "Âm thanh mở khóa",
    call: "Tone cuộc gọi",
    speak: "Tone giọng nói",
    busy: "Âm thanh báo bận",
    tip1: "Nhấp để tải lên tệp .wav",
    tip2: "Kích thước tệp không quá 1M",
    tip3: "Vui lòng tải lên tệp .wav",
    tip4: "Xin hãy tải lên mọi tệp",
    add: "Tạo tệp",
  },
  validate: {
    noEmail: "Email không thể để trống, hãy nhập lại",
    noPhone: "Số điện thoại không được để trống, hãy nhập lại",
    errorReg:
      "Độ dài nhập là từ 1-50 chữ số, bạn có thể nhập chữ cái viết hoa và viết thường, số, ký hiệu - . _ @",
    noPassword: "Mật khẩu không được để trống, hãy nhập lại",
    pwdReg:
      "Độ dài nhập mật khẩu là từ 8-25 chữ số, chỉ và phải chứa số và chữ cái",
    pwdCheck: "Hai mật khẩu đã nhập không khớp, vui lòng nhập lại",
    pwdLengthReg: "Độ dài mật khẩu từ 8 đến 25, vui lòng xác nhận đầu vào",
    noCode: "Vui lòng nhập mã xác minh",
    codeReg: "Vui lòng nhập mã xác minh gồm 6 chữ số",
    nullText: "Dữ liệu không được để trống, hãy nhập lại.",
    phoneCheck: "Số điện thoại nhập hai lần không khớp, vui lòng nhập lại.",
    emailNumReg: "Độ dài email nhập phải từ 6-50 ký tự, vui lòng nhập lại.",
    emailReg: "Email không hợp lệ, vui lòng nhập lại.",
    emailCheck: "Tài khoản email nhập hai lần không khớp, vui lòng nhập lại.",
    noUsername: "Mật khẩu không được chứa số tài khoản, vui lòng nhập lại.",
    accountReg: "Tên tài khoản chưa đúng, vui lòng nhập lại.",
  },
  area: {
    areaTitle: "Quản lý vùng",
    add: "Thêm",
    area: "Vùng",
    addNextArea: "Tạo khu vực phụ mới",
    areaNameTip: "Vui lòng nhập tên khu vực",
    areaNameHold: "Độ dài nhập từ 1-20 chữ số, không thể nhập ký tự đặc biệt",
    areaNumTip: "Vui lòng nhập số khu vực",
    areaName: "Tên",
    checkAreaName: "Tên khu vực không được trống, hãy nhập lại",
    areaNameTip1: "Tên k.vực không để trống",
    areaNameTip2: "Tên khu vực chưa đúng, vui lòng nhập lại.",
    areaNum: "Số khu vực",
    checkAreaNum: "ID khu vực không thể trống, hãy nhập lại",
    lastLevel: "Thuộc về khu vực cấp trên",
    checkLastLevel: "Khu vực cấp trên không được để trống, vui lòng chọn lại",
    lastLevelTip: "Vui lòng chọn khu vực cha mà bạn thuộc về",
    delInfo:
      "Thực hiện nhiệm vụ xóa này sẽ xóa dữ liệu trong khu vực này và không thể khôi phục.",
    oneStep: "Mức 1",
    twoStep: "Mức 2",
    threeStep: "Mức 3",
    fourStep: "Mức 4",
    fiveStep: "Mức 5",
    delAreaTip: "Có khu vực phụ, không thể xóa",
    personArea: "Người dùng chưa được liên kết ",
    areaType: "Cách thêm",
    addArea1: "Thêm riêng",
    addArea2: "Thêm liên tục",
    addArea3: "Thêm ma trận",
    areaNameTop: "Tiền tố tên vùng",
    areaNameLast: "Hậu tố tên vùng",
    areaJoinHold: "Vui lòng nhập tiền tố tên miền",
    areaJoinHold1: "Vui lòng nhập hậu tố tên khu vực",
    startNum: "Số bắt đầu",
    checkStartNum: "Nhập số bắt đầu sai, vui lòng nhập lại.",
    checkStartNum1: "Nhập số bắt đầu không được để trống, vui lòng nhập lại.",
    checkEndNum: "Nhập số kết thúc sai, vui lòng nhập lại.",
    checkEndNum1: "Số kết thúc không được trống, hãy nhập lại.",
    endNum: "Số kết thúc",
    topStart: "Số bắt đầu tiêu đề",
    checkTopStart:
      "Nhập số bắt đầu đầu tiên không chính xác, vui lòng nhập lại.",
    checkTopStart1:
      "Nhập số bắt đầu đầu tiên không được để trống, vui lòng nhập lại.",
    topEnd: "Số kết thúc đầu",
    checkTopEnd: "Nhập số kết thúc của tiêu đề không đúng, vui lòng nhập lại.",
    checkTopEnd1: "Số kết thúc đầu tiên không được trống, hãy nhập lại.",
    lastStart: "Số bắt đầu đuôi",
    checkLastStart: "Thông tin số đầu cuối bị sai, vui lòng nhập lại.",
    checkLastStart1: "Số đầu cuối không được trống, vui lòng nhập lại",
    lastEnd: "Số kết thúc đuôi",
    checkLastEnd: "Nhập số kết thúc đuôi bị sai, vui lòng nhập lại.",
    checkLastEnd1: "Số kết thúc đuôi không được để trống, vui lòng nhập lại.",
    topTip:
      "Độ dài nhập từ 1-2 chữ số, chỉ có thể nhập số, và phạm vi số là 1-99",
    lastTip:
      "Độ dài nhập từ 1-2 chữ số, chỉ có thể nhập số, và phạm vi số là 1-99",
    areaNameTest: "Ví dụ tên khu vực",
  },
  addressBook: {
    config: "Cấu hình dự án",
    errorTip: "Lỗi định dạng sổ địa chỉ",
    upgrade: "Quản lý nâng cấp sổ địa chỉ",
    deviceIdTip: "Vui lòng nhập ID thiết bị",
    deviceId: "ID t.bị",
    syncAll: "Đồng bộ tất cả",
    sync: "Đồng bộ",
    sysVersion: "Phiên bản danh bạ hệ thống hiện tại",
    deviceVersion: "Phiên bản danh bạ thiết bị hiện tại",
    syncTip: "Lệnh đồng bộ đã được phát hành thành công",
  },
  newarea: {
    add: "Thêm khu vực",
    edit: "Sửa khu vực",
    smallTip: "Hiện tại là cấp độ khu vực nhỏ nhất, không thể thêm khu vực con",
    batch: "Thêm theo lô",
    batch1: "Thêm liên tục",
    batch2: "Thêm ma trận",
  },
  deviceSip: {
    saveTip:
      "Vui lòng xuất sổ địa chỉ kịp thời, nếu không tất cả dữ liệu sẽ bị xóa sau khi thoát trang.",
    devMsg: "Thông tin thiết bị",
    list: "Danh sách",
    add: "Thêm thiết bị",
    edit: "Sửa thiết bị",
    batch: "Thêm hàng loạt",
    areaChosen: "Lựa chọn cấp khu vực",
    areaNum: "Số lượng thiết bị mới ở mỗi khu vực",
    bacthTip:
      "Nếu Cấp khu vực được đặt thành Tòa nhà và số lượng thiết bị mới ở mỗi khu vực là 4, bốn thiết bị mới sẽ được thêm vào mỗi tòa nhà đã được tạo",
    note: "minh hoạ",
    baseConfig: "Cấu hình thông tin cơ bản",
    deviceName: "Tên thiết bị",
    nameTip: "Cố định thêm một số vào tên của nhóm mà nó thuộc về",
    function: "Chức năng hỗ trợ",
    net: "Cấu hình mạng",
    netType: "Loại mạng",
    netTip1:
      "Mạng tĩnh là mạng tĩnh, bạn cần cài đặt thủ công IP và các thông tin khác.",
    netTip2:
      "DHCP là mạng động, các thông tin như IP được cấp phát tự động bởi bộ định tuyến.",
    mask: "Vui lòng nhập mặt nạ con",
    gateway: "Vui lòng nhập cổng",
    ip: "Vui lòng nhập địa chỉ IP",
    ipTip: "Địa chỉ IP nhập phải tránh các IP đặc biệt, ví dụ như 127.0.0.1.",
    dns1: "Hãy nhập DNS1",
    dns2: "Hãy nhập DNS2",
    sip1: "Cấu hình thông tin SIP1",
    config: "Cấu hình thông tin",
    mode: "Chế độ",
    mode1: "Chế độ trực tiếp",
    mode2: "Chế độ máy chủ",
    user: "Vui lòng nhập tên người dùng",
    userTitle: "Tên người dùng",
    userTip: "Mặc định là tên nhóm cộng với số, ví dụ: 1-1-1",
    last: "Vui lòng nhập hậu tố tài khoản",
    sipTip:
      "Vui lòng nhập tên người dùng và mật khẩu đã đăng ký với máy chủ SIP",
    password: "Vui lòng nhập mật khẩu",
    passwordTitle: "Mật khẩu",
    serverIp: "Hãy nhập serverIP",
    protocolType: "Vui lòng chọn loại giao thức",
    protocolTypeTitle: "Loại giao thức",
    sip2: "Cấu hình thông tin SIP2",
    more: "Hơn..",
    close: "Dừng",
    formatError: "Định dạng lỗi, hãy nhập lại",
    forbidTip: "127.0.0.1 không được phép, vui lòng nhập lại",
    call: "Gọi vào và gọi ra",
    monitor: "Màn hình",
    lift: "Điều khiển thang máy",
    rtsp: "Luồng video RTSP",
    deviceTip: "Chức năng hỗ trợ thiết bị không thể trống, vui lòng chọn lại",
    maskTip1: "Mặt nạ mạng con không thể trống, hãy nhập lại",
    maskTip2: "Mặt nạ mạng con bị sai định dạng, vui lòng nhập lại",
    gatewayTip1: "Cổng không thể trống, vui lòng nhập lại",
    gatewayTip2: "Lỗi định dạng cổng, hãy nhập lại",
    ipTip1: "Địa chỉ IP không được trống, vui lòng nhập lại",
    ipTip2:
      "Lỗi định dạng địa chỉ IP, giới hạn trên là 255.254.254.253, phân đoạn đầu tiên không phải 0, hãy nhập lại",
    dns1Tip1: "DNS1 không thể trống, hãy nhập lại",
    dns1Tip2: "Lỗi định dạng DNS1, hãy nhập lại",
    dns2Tip1: "Lỗi định dạng DNS2, hãy nhập lại",
    passwordTip1: "Mật khẩu không thể trống, hãy nhập lại",
    serviceTip1: "ServiceIp không thể trống, hãy nhập lại",
    serviceTip2: "Lỗi định dạng serviceIp, hãy nhập lại",
    sip2Tip: "Nếu bạn đã định cấu hình SIP2, hãy điền thông tin theo quy tắc",
    devnameTip1: "Tên thiết bị không được trống, hãy nhập lại",
    devnameTip2: "Lỗi định dạng tên thiết bị, hãy nhập lại",
    nameTip1: "Tên người dùng không được để trống, hãy chọn lại",
    nameTip2: "Tên người dùng không được để trống, hãy chọn lại",
    maxTip1:
      "Số lượng thiết bị trong khu vực hiện tại đã đạt tối đa là 8 và không thể thêm vào",
    area: "Khu vực",
    editArea: "Sửa khu vực",
    addArea: "Thêm khu vực",
    batchArea: "Thêm hàng loạt",
    deleteArea: "Xóa khu vực",
    areaName: "Tên khu vực",
    areaNo: "Số khu vực",
    importAddr: "Nhập sổ địa chỉ",
    next: "Tiếp theo",
    areaTip1: "Hãy chọn khu vực muốn chỉnh sửa trước",
    areaTip2: "Hãy chọn khu vực cần xóa trước",
    areaTip3:
      "Khu vực hiện tại của bạn trống, không thể thêm thiết bị theo lô lúc này, hãy thêm thông tin khu vực trước.",
    noArea: "Không có cấu hình vùng",
    error: "Lỗi dữ liệu",
    addDevice: "Thêm thiết bị",
    editDevice: "Sửa thiết bị",
    delDevice: "Xóa thiết bị",
    batchDevice: "Thêm hàng loạt",
    prev: "Trước",
    updateAddr: "Cập nhật sổ địa chỉ",
    saveAddr: "Lưu sổ địa chỉ",
    exportAddr: "Xuất sổ địa chỉ",
    deleteTip: "Có xóa thiết bị hay không?",
    deleteTip2:
      "Hiện tại đã chọn vùng, vui lòng quay lại cấu hình vùng để xóa.",
    deleteTip3: "Vui lòng chọn thiết bị bạn muốn xóa trước",
    deviceTip1: "Vui lòng chọn thiết bị bạn muốn sửa trước",
    deviceTip2: "Vui lòng chọn khu vực trước, sau đó thêm thiết bị",
    exportSuccess: "Xuất thành công",
    xmlTip: "Vui lòng tải lên tệp XML của sổ địa chỉ",
    xmlTip1: "Vui lòng chọn tệp XML sẽ tải lên",
    xmlTip2:
      "Sổ địa chỉ nhập vào không khớp với cấp độ cộng đồng hiện tại, việc nhập đã thất bại",
    areaConfig: "Cấu hình khu vực",
    deviceConfig: "Cấu hình thiết bị",
    exportConfig: "Xem trước xuất",
    projectConfig: "Cấu hình dự án",
    prevArea: "Khu vực mẹ mà nó thuộc về",
    areaNoTip: "Nếu số bắt đầu lớn hơn số kết thúc, vui lòng điền lại số",
    smallAreaTip:
      "Hiện tại là cấp độ khu vực nhỏ nhất, không thể thêm vùng phụ.",
    areaNoTip1:
      "Nếu số bắt đầu của phần đầu tiên lớn hơn số kết thúc của phần đầu tiên, vui lòng điền lại",
    areaNoTip2:
      "Số bắt đầu của đuôi lớn hơn số cuối của đuôi, vui lòng điền lại",
  },
  push: {
    list: "Đẩy bản ghi",
    productType: "Số sản phẩm",
    softwareName: "Tên phần mềm",
    versionNo: "Số phiên bản",
    time: "Thời gian đẩy",
    invalidTime: "Thời gian hết hạn",
    upgrade: "Nâng cấp",
    upgradeRecord: "Lịch sử nâng cấp",
    deviceType: "Loại thiết bị",
    deviceName: "Tên thiết bị",
    currentSoftName: "Tên phần mềm thiết bị",
    currentSoftNo: "Số phiên bản thiết bị",
    upgradeNo: "Số phiên bản phần mềm nâng cấp",
    filterTip1: "Vui lòng nhập tên thiết bị",
    filterTip2: "Vui lòng chọn tên phần mềm",
    filterTip3: "Vui lòng chọn số phiên bản",
    checkTip: "Chọn kích hoạt",
    ota: "Nâng cấp OTA",
    taskName: "Tên nhiệm vụ",
    taskNameTip: "Nhập tên nhiệm vụ",
    binName: "Tên firmware",
    upgradeType: "Phương pháp nâng cấp",
    done: "Có thực hiện ngay không?",
    upgradeTime: "Thời gian nâng cấp",
  },
  check: {
    submit: "Chúc mừng, việc gửi đã thành công!",
    noSubmit: "Rất tiếc, việc gửi thất bại!",
    file: "Chọn tài liệu",
    noFile: "Không có tệp được chọn",
    projectName: "Tên dự án",
    projectNameTip: "Vui lòng nhập tên dự án",
    describe: "Mô tả",
    contentTip: "Hãy nhập nội dung",
    areaType: "Hệ thống phân cấp vùng",
    example: "Ví dụ: số tòa nhà-đơn vị-phòng",
    areaTip: "Định dạng số khu vực sai, vui lòng nhập lại",
    areaNameTip: "Vui lòng nhập tên lớp",
    nameTip: "Tên không được trống, vui lòng nhập lại",
    nameError: "Tên đã nhập sai, vui lòng nhập lại",
    nameLength: "Độ dài nhập tên là 4 ~ 50, vui lòng nhập lại",
    areaNullTip: "Cấp độ khu vực không thể trống",
    formateError: "Độ dài là 1-6 chữ số, không thể nhập ký hiệu đặc biệt",
    noAreaTip: "Cấp độ khu vực không thể trống, hãy chọn lại",
    maxFileTip: "Tệp quá giới hạn",
    xmlTip: "Vui lòng tải lên tệp định dạng XML",
  },
  book: {
    areaBy: "Vùng",
    list: "Danh sách trùng thông tin thiết bị ",
    repeatTip:
      "Thông tin thiết bị dưới đây bị trùng lặp. Vui lòng sửa thông tin thiết bị trùng. Sau khi nhấn 'Xác nhận', hệ thống sẽ kiểm tra sự trùng lặp thông tin nhập thiết bị.",
    coverTip:
      "Thao tác này sẽ ghi đè lên dữ liệu thêm hàng loạt của cấp độ hiện được chọn",
    batchTip: "Phạm vi IP được tạo bằng cách thêm thiết bị theo lô",
  },
  updateNewSip: {
    otaDeleteTip: "Xóa thất bại, chỉ được xóa các tác vụ chưa bắt đầu",
    deleteArea1: "Có xóa khu vực hay không",
    deleteArea2:
      "Đồng thời, tất cả các khu vực và thiết bị dưới khu vực này sẽ bị xóa cùng nhau",
    codeRepeatTip:
      "Không thể lặp lại ID khu vực của cùng một cấp, vui lòng nhập lại ID khu vực hiện tại",
    nameRepeatTip:
      "Tên khu vực ở cùng cấp không thể trùng lặp, vui lòng nhập lại tên khu vực hiện tại",
    deviceIp: "IP thiết bị",
    callin: "Gọi vào",
    callout: "Gọi ra",
    systemMsg: "Thông tin hệ thống",
    batchIpTip: "Phạm vi IP được tạo bằng cách thêm thiết bị theo lô lần này",
    ip: "Địa chỉ IP",
    mask: "Mặt nạ con",
    gateway: "Cổng",
    noData: "Không",
    noAddressTip: "Hiện tại không có dữ liệu sổ địa chỉ có thể đồng bộ",
    operator: "Toán tử",
    goTip: "Nhấp để chuyển đến bước tương ứng",
    deviceNameTip:
      "Độ dài đầu vào là 1-16 chữ số, không thể nhập ký hiệu đặc biệt",
    filter1: "Nhập tên khu vực để lọc",
    filter2: "Nhập tên khu vực hoặc tên thiết bị để lọc",
    secret: "Mật khẩu mã hóa",
    secretTip:
      "Vui lòng nhập mật khẩu trong vòng 32 ký tự, định dạng không giới hạn",
    noSecretTip: "Mật khẩu mã hoá chưa được đặt, có thể bỏ qua",
    setSecret: "Đặt mật khẩu mã hóa sổ địa chỉ",
    ignore: "Bỏ qua",
    emptyBookTip: "Sổ địa chỉ trống và không thể xuất tạm thời",
    errorSecret: "Lỗi mật khẩu mã hóa sổ địa chỉ, vui lòng nhập lại",
    other: "Khác",
    doorAuth: "Kiểm soát truy cập",
    funTitle: "Vui lòng kiểm tra các chức năng hỗ trợ bởi thiết bị đã thêm",
    callInTip: "Thiết bị hỗ trợ gọi",
    callOutTip: "Thiết bị hỗ trợ nhận cuộc gọi",
    monitorTip: "Thiết bị hỗ trợ được giám sát",
    doorTip: "Thiết bị hỗ trợ chức năng mở khóa",
    liftTip: "Thiết bị hỗ trợ điều khiển thang máy",
    maskTip: "Vui lòng nhập mặt nạ mạng con, tham chiếu: 255.255.255.255",
    gatewayTip: "Vui lòng nhập cổng, định dạng tham khảo 1.1.1.1",
    ip1: "Vui lòng nhập địa chỉ IP, định dạng tham khảo 1.1.1.1",
    ipTip: "Địa chỉ IP đầu vào cần tránh IP đặc biệt như: 127.0.0.1, v.v..",
    dns1: "Vui lòng nhập DNS1, tham chiếu: 1.1.1.1",
    dns2: "Vui lòng nhập DNS2, tham chiếu: 1.1.1.1",
    serverIp: "Vui lòng nhập serverIp, tham chiếu: 1.1.1.1 hoặc tên miền",
    successxml: "Tệp đã phân tích thành công",
    groupCall: "Gọi nhóm",
    groupCallTip:
      "Sau khi bật, có thể gọi tất cả thiết bị trong nhóm bằng cách nhấp vào biểu tượng gọi nhóm.",
    record: "Bản ghi phiên bản",
    export: "Xuất",
    sync: "Đồng bộ",
    communityTip:
      "Hiện có dữ liệu thiết bị khu vực, không thể thay đổi cấp độ khu vực",
    areaNameTitle: "Mô tả phân cấp",
    noDataTip: "Hiện tại không có dữ liệu",
    areaCodeDescriptionTip:
      "Mô tả phân cấp không được để trống, vui lòng điền đầy đủ",
    moduleName: "Công cụ cấu hình sổ địa chỉ",
    userSipAccount: "Được cố định là số vùng của nhóm cha + số thiết bị.",
    devMax: "Nút thiết bị vượt quá giới hạn 10.000 mục, không thể thêm",
    areaMax: "Nút khu vực vượt quá giới hạn 10.000 mục, không thể thêm",
    ipAndMaskTip1:
      "Địa chỉ IP liên kết với mặt nạ mạng con, cần vượt qua xác thực logic kinh doanh với kết quả toàn 1 hoặc toàn 0 sau phép toán AND theo bit.",
    ipAndMaskTip2:
      "Nếu xảy ra lỗi quy tắc xác thực kinh doanh, vui lòng sửa đổi địa chỉ IP tương ứng.",
    ipAndMaskTip3:
      "Các quy tắc xác thực kinh doanh của mặt nạ mạng con và địa chỉ IP không đúng. Vui lòng sửa đổi địa chỉ IP.",
    ipAndMaskTip4:
      "Khi thêm hàng loạt thiết bị, các IP không đáp ứng xác thực logic kinh doanh sẽ tự động bị bỏ qua.",
    correctMaskTip: "Vui lòng điền đúng mặt nạ mạng con trước.",
    correctIpTip: "Vui lòng nhập đúng địa chỉ IP.",
  },
  newDeviceType: {
    indoorMachine: "Màn hình trong nhà",
    doorPhone: "Điện thoại sảnh",
    smallDoor: "Trạm ngoài trời",
    manage: "Trạm bảo vệ",
    wall: "Thiết bị treo tường",
    monitor: "Camera mạng",
    unitGuard: "Máy quản lý đơn vị",
    networkCard: "Đầu đọc card mạng",
    unitCard: "Đầu đọc thẻ",
    lift: "Mô-đun liên kết thang máy",
    deviceTypeTip: "Hãy chọn loại thiết bị",
  },
  threeProject: {
    hotWater: "Hệ thống nước nóng",
    cho: "Fomandehit (Formaldehyde)",
    config: "Cấu hình",
    unconfig: "Không cấu hình",
  },
  elevator: {
    title: "Tạo Cấu hình Kiểm soát Thang máy",
    label: "Tải lên Bảng Cấu hình Kiểm soát Thang máy",
    uploadTip: "Nhấp hoặc kéo tệp vào khu vực này để tải lên",
    upload: "Tải lên",
    download: "Tải xuống Mẫu",
    downloadTip: "Nhấp để tải xuống mẫu cấu hình kiểm soát thang máy",
    error1:
      "[Tầng vật lý] không hợp lệ. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    error2:
      "[Tầng hiển thị] không hợp lệ. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    error3:
      "[Địa chỉ Cổng kết nối Thang máy] không hợp lệ. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    error4:
      "[Hiển thị Số thang máy] không hợp lệ. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    error5:
      "[IP Thiết bị] không hợp lệ. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    error6:
      "[Cổng kết nối Thang máy] vượt quá giới hạn số lượng. Vui lòng kiểm tra tệp cấu hình và tải lại.",
    generate: "Mẫu Cấu hình Kiểm soát Thang máy",
    fileLabel: "Tệp Cấu hình Kiểm soát Thang máy:",
    tip: "Vui lòng đặt tệp cấu hình vào mục [Nâng cấp Tài nguyên] trong công cụ PC để nhập vào thiết bị.",
    downloadfile: "Tải xuống",
    fileName: "CauHinhKiemSoatThangMay.xlsx",
    formatError:
      "Định dạng tệp tải lên không đúng, vui lòng kiểm tra nội dung tệp và tải lại",
  },
};
